import { component } from 'picoapp';
import Drawer from 'utils/drawer';

export default component(async (node) => {
  const drawerElement:HTMLElement = node.querySelector('[data-drawer]');
  const closeButton:HTMLElement = node.querySelector('[data-close]');
  const openButton:HTMLButtonElement = document.querySelector('[data-open="usp-drawer"]');
  const drawer = Drawer(drawerElement);

  closeButton.addEventListener('click', () => {
    drawer.close();
  });

  openButton.addEventListener('click', () => {
    drawer.open();
  });

  drawer.on('open', async () => {
    const disableScroll = (await import(
      /* webpackChunkName: "scroll-lock" */
      'modules/scroll-lock'
    )).default.disablePageScroll;
    disableScroll(node);
  });

  drawer.on('closed', async () => {
    const enableScroll = (await import(
      /* webpackChunkName: "scroll-lock" */
      'modules/scroll-lock'
    )).default;

    enableScroll.clearQueueScrollLocks();
    enableScroll.enablePageScroll(node);
  });
});
